import { Injectable } from '@angular/core';
import { RestApi } from 'app/auth/rest.api';
import { Observable } from 'rxjs';
import { IConnectRepositoryFolder } from './IConnectRepositoryFolder';
import { IConnectRepository, IConnectRepositoryEnvironmentParams } from './IConnectRepository';
import { IExternalSystem } from './IExternalSystem';


@Injectable()
export class ConnectEcmService {

  baseUrlExt = 'api/ExternalSystem/ECM';

  constructor(private _restApi: RestApi) { }

  getExternalSystems(): Observable<IExternalSystem[]> {
    return this._restApi.get(`${this.baseUrlExt}`);
  }

  getRepository(id: string): Observable<IConnectRepository> {
    return this._restApi.get(`${this.baseUrlExt}/Repository/${id}`);
  }

  connectToRepositories(params: IConnectRepositoryEnvironmentParams): Observable<any> {
    return this._restApi.post(`${this.baseUrlExt}/Repository/Connection`,
      { username: params.username, password: params.password, url: params.url }).map((res) => {
        let repositories: any;
        if (res) {
          repositories = [];
          res.forEach(repo => {
            repositories.push(JSON.parse(repo));
          });
        }

        return repositories;
      });
  }

  updateRepository(repository: IConnectRepository): Promise<any> {
    delete repository.nodes;
    return this._restApi.put(`${this.baseUrlExt}/Repository/${repository.id}`, repository).toPromise();
  }

  getConnectionFolders(repositoryId: string, params: IConnectRepositoryEnvironmentParams, externalId?: string): Promise<any> {
    return this._restApi.post(`${this.baseUrlExt}/Folder/Connection`,
      { username: params.username, password: params.password, url: params.url, repositoryId, folderId: externalId }).toPromise();
  }

  getFolder(folderId: string): Promise<IConnectRepositoryFolder> {
    return this._restApi.get(`${this.baseUrlExt}/Folder/${folderId}`).toPromise();
  }

  updateFolder(folder: IConnectRepositoryFolder, folderId: string): Promise<any> {
    return this._restApi.put(`${this.baseUrlExt}/Folder/${folderId}`, folder).toPromise();
  }

  getMetadata() {
    return this._restApi.get(`${this.baseUrlExt}/Metadata`).toPromise();
  }

}
